const UrlName = '/exam/v1'
const monitorUrl = "/monitor/v1"
export default API => ({
    // 获取目录
  

    queryLinkLiveData(params) {
        return API({ url: `${UrlName}/userPaper/monitor/queryLinkLiveData`, method: 'get', params});
      },
      isPhotoRequired(data) {
        return API({ url: `${monitorUrl}/monitorCaptureRecord/isNeedPhoneCapture`, method: 'post', data});
      },
      sendPictureBase(data) {
        return API({ url: `${monitorUrl}/monitorCaptureRecord/saveCapture`, method: 'post', data});
      }, 
      sendPicturesBase(data) {
        return API({ url: `${monitorUrl}/monitorCaptureRecord/saveCaptures`, method: 'post', data});
      }, 
      getInfo(params) {
        return API({ url: `${UrlName}/userPaper/monitor/queryTKData`, method: 'get', params});
      }, 
      getExam(params) {
        return API({ url: `${UrlName}/exam/findExamForPhoneVideo`, method: 'get', params});
      }, 
      liveSuccess(params) {
        return API({ url: `${UrlName}/userPaper/monitor/linkLiveSucc`, method: 'get', params});
      }, 
      isExamStop(params) {
        return API({ url: `${UrlName}/userPaper/monitor/userPaperLifeCycle`, method: 'get', params});
      }, 
      switchScreen(params) {
        return API({ url: `${UrlName}/userPaper/monitor/userSwitchScreen`, method: 'get', params});
      }, 
})
